<template>
	<section>
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('id')"       >ID		<font-awesome-icon v-if="direction.by == 'id'"       :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('nome')"     >NOME		<font-awesome-icon v-if="direction.by == 'nome'"     :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('cidade')"   >CIDADE	<font-awesome-icon v-if="direction.by == 'cidade'"   :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('estado')"   >ESTADO	<font-awesome-icon v-if="direction.by == 'estado'"   :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('telefone')" >TELEFONE	<font-awesome-icon v-if="direction.by == 'telefone'" :icon="order_icon" size="xs" /></th>
    			<th></th>
    		</thead>

			<transition mode="out-in" name="leftIn">
				<tbody v-if="unidades" align="center">
	    			<tr v-if="unidades.result.data == null">
	    				<td colspan="6">Nenhum registro encontrado</td>
	    			</tr>

	    			<tr v-else v-for="(uni, index) in unidades.result.data" :key="index">
						<td>{{ uni.id }}</td>
						<td>{{ uni.nome }}</td>
						<td>{{ uni.cidade }}</td>
						<td>{{ uni.estado }}</td>
						<td>{{ Phone(uni.telefone) }}</td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(uni)" /></td>
					</tr>

	    		</tbody>
	    		<div v-else><Loading/></div>
			</transition>
    	</table>

    	<controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
    	<modalUni :data="modal_data" :action="action"  @alert="show_alert" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import filtros  from "@/components/Tools/Filtro.vue"
	import controls from "@/components/Tools/Table_Control.vue"
	import modalUni from "@/components/Modal/Cadastro/Unidade.vue"

	export default {
		props: ["table", "method"],
		mixins: [api, replace],
		components: { 
			controls, 
			modalUni, 
			filtros 
		},

		data() { 
			return {
				unidades: null,
				constrol_data: {},
				modal_data: {},
				action: "",

				direction: { 
					order: "asc", 
					by: "id" 
				},

				pagination: "10?",
				string_filter: "",

				filter_data: [
					{ 
						name: "nome",   
						label: "Nome",   
						type: "text", 
						data_get: ""
					},
					{ 
						name: "cidade", 
						label: "Cidade", 
						type: "text", 
						data_get: ""
					},
					{ 
						name: "estado", 
						label: "Estado", 
						type: "text", 
						data_get: ""
					},
				]
			}
		},

		created() {
			this.$emit('update:pdf', true);
			this.$emit('update:pdf_title', 'unidades');
			this.$emit('update:pdf_external', false);
			this.$emit('update:pdf_datatable', 'Unidade');
			this.$emit('update:pdf_header', ["ID", "NOME", "CIDADE", "ESTADO", "TELEFONE"] );
			this.$emit('update:pdf_body', ["id", "nome", "cidade", "estado", "telefone"] );
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`;
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down";
			}
		},

		methods: {
			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc';
				}else{
					this.direction.by = payload;
				}

				this.get_data();
			},

			filtrar(payload) {
				this.string_filter = payload;
				this.$emit('update:pdf_string_filter', payload);
				this.get_data();
			},

			is_super_adm() {
				if(this.$store.state.user.type !== 3){
					return "&id="+this.$store.state.user.unidade_id;
				}else {
					return "";
				}
			},

			async get_data() {
				this.unidades = null;
				var unidade_filtro = this.is_super_adm();
				this.unidades = await this.GET("Unidade", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}${unidade_filtro}`);

				this.constrol_data = {
					current_page: this.unidades.result.current_page,
					last_page:    this.unidades.result.last_page,
					per_page:     this.unidades.result.per_page,
					total:        this.unidades.result.total,
				}
			},

			navigate(payload) {
				this.pagination = payload;
				this.get_data();
			},

			view(unidade) { 
				this.modal_data = unidade;
				this.action = "view";
				$("#modal-cadastro-unidade").modal();
			},

			add() { 
				this.modal_data = {};
				this.action = "add";
				$("#modal-cadastro-unidade").modal();
			},

			show_alert(payload) {
				$("#modal-cadastro-unidade").modal('hide');
				this.get_data();

				this.$emit('alert', payload);
			},
		},
	};
</script>

<style>
	
</style>